// Utils
import * as pointsLib from '../../../common/maths/geometry/point';
import { getGridSizeLocalStorage } from './gridSizeStorageService';

import { GRID, GRID_SIZE_LIST, GRID_SIZE_LIST_TOUCH_DEVICE } from './gridConstants';

export const pixelsToGridPoints = (pixels, gridSize) => Math.round(pixels / gridSize);
export const pixelsToPrevGridPoints = (pixels, gridSize) => Math.floor(pixels / gridSize);
export const pixelsToNextGridPoints = (pixels, gridSize) => Math.ceil(pixels / gridSize);
export const gridPointsToPixels = (gridPoints, gridSize) => gridPoints * gridSize;

export const roundPixelToNearestGridPoint = (pixels, gridSize) =>
    gridPointsToPixels(pixelsToGridPoints(pixels, gridSize), gridSize);
export const roundPixelToNextGridPoint = (pixels, gridSize) =>
    gridPointsToPixels(pixelsToNextGridPoints(pixels, gridSize), gridSize);

const getGridSizeForWidth = (screenWidth, gridSizeList) =>
    gridSizeList.reduce((currValue, size) => (size.breakpoint >= screenWidth ? currValue : size), gridSizeList[0]);

export const calculateGridSize = (screenWidth, screenHeight, isTouchDevice) => {
    if (isTouchDevice) {
        return getGridSizeForWidth(Math.max(screenWidth, screenHeight), GRID_SIZE_LIST_TOUCH_DEVICE);
    }

    return getGridSizeForWidth(screenWidth, GRID_SIZE_LIST);
};

export const getGridSizeBodyClassName = (sizeName) => `app-size-${sizeName}`;

/**
 * TODO - Improve this API & function name
 */
export const getElementStyle = (widthGU, gridSize, noSetWidth) => ({
    // Need to subtract 2 from the width as the border is no longer part of the element size
    // It's now an absolutely positioned pseudo element :before, so the element itself must be 2px smaller
    // to account for the border
    width: !noSetWidth ? gridPointsToPixels(widthGU, gridSize) - 2 : 'auto',
});

export const positionPixelsToGridPoints = (position, gridSize) =>
    pointsLib.round(pointsLib.scale(1 / gridSize, position));

/**
 * Scales "large grid pixels" into the appropriate number of pixels for the current grid size.
 * E.g. 10px in the large grid size would scale to 8px in the small grid size.
 */
export const scaleToGrid = (units, gridSize) => (gridSize / GRID.LARGE.size) * units;

/**
 * Scales pixels to the large grid pixels, based on the current grid size.
 * E.g. 8px when viewing the small grid size would scale up to 10px for the large grid size.
 */
export const scaleToLargeGridPixels = (units, gridSize) => (GRID.LARGE.size / gridSize) * units;

export const getStoredGridSize = () => {
    const storedGridSize = getGridSizeLocalStorage();
    return GRID_SIZE_LIST.find(({ name }) => name === storedGridSize);
};

export const isSmallGridSize = (gridSize) => gridSize === GRID.SMALL.size;
export const isMediumGridSize = (gridSize) => gridSize === GRID.MEDIUM.size;
export const isLargeGridSize = (gridSize) => gridSize === GRID.LARGE.size;
